import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  connectId: validator('number', {
    allowString: true,
    allowBlank: true,
  }),
  siteId: validator('number', {
    allowString: true,
    allowBlank: true,
  }),
  status: [validator('presence', true), validator('number')],
});

export default class FrontendUserModel extends Model.extend(Validations) {
  @attr('boolean') channelEmail;
  @attr('string') city;
  @attr('string') company;
  @attr('number') connectId;
  @attr dob;
  @attr('string') email;
  @attr('string') firstName;
  @attr('string') gender;
  @attr lastLogin;
  @attr('string') lastName;
  @attr('string') mobileNumber;
  @attr('string') region;
  @attr('number') siteId;
  @attr('number', { defaultValue: 0 }) status;
  @attr('string') street;
  @attr unlockedAt;
  @attr('string') zipCode;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return `${this.firstName} ${this.lastName}`;
  }

  get displayLabel() {
    return `${this.firstName} ${this.lastName}`;
  }
}
